function setupReadMoreReadLess() {
  const readMorePairs = document.querySelectorAll('.readMorePair');

  readMorePairs.forEach(pair => {
    const readMoreBTN = pair.querySelector('.readMore_btn');
    const readMoreParentContent = pair.querySelector('.show_more_prodDescription');
    
    const readLessBTN = pair.querySelector('.readLess_btn');
    const readLessContent = pair.querySelector('.show_less_prodDescription');

    readMoreBTN.addEventListener('click', () => {
      readMoreBTN.style.display = 'none';
      readMoreParentContent.style.display = 'none';

      readLessBTN.style.display = 'block';
      readLessContent.style.display = 'block';
    });

    readLessBTN.addEventListener('click', () => {
      readLessBTN.style.display = 'none';
      readLessContent.style.display = 'none';

      readMoreBTN.style.display = 'inline';
      readMoreParentContent.style.display = 'block';
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setupReadMoreReadLess();
});
